/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentGradeDetailViewModel } from "../types/StudentGradeDetailViewModel.ts";
import { gradeSimulationTccItemViewModelSchema } from "./gradeSimulationTccItemViewModelSchema.ts";
import { studentGradeModuleViewModelSchema } from "./studentGradeModuleViewModelSchema.ts";

export const studentGradeDetailViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula do aluno."),
  ),
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  personName: z.string().describe("Nome completo do aluno.").nullish(),
  classStudentName: z
    .string()
    .describe("Nome da turma no formato 'Código - Descrição'.")
    .nullish(),
  finalGrade: z
    .number()
    .describe(
      "Média geral na escala 0-10, calculada como média aritmética das médias ponderadas das Disciplinas marcadas como IsIncludedInGradeCalculation, acrescida das notas de TCC quando existirem. Opcional.",
    )
    .nullish(),
  finalFrequency: z
    .number()
    .describe(
      "Frequência geral em %, calculada como média das frequências das Disciplinas marcadas como IsIncludedInAttendanceCalculation. Opcional.",
    )
    .nullish(),
  modules: z
    .array(z.lazy(() => studentGradeModuleViewModelSchema))
    .describe(
      "Lista de módulos do aluno, ordenados pela data da primeira aula. Cada módulo contém suas disciplinas com médias, frequências e aulas detalhadas.",
    )
    .nullish(),
  tccGrades: z
    .array(z.lazy(() => gradeSimulationTccItemViewModelSchema))
    .describe(
      "Notas do TCC (TCC001 — Resultados Preliminares e TCC002 — Projeto de Pesquisa), quando existirem e o prazo estiver ativo ou vencido. Entram na média geral como termos adicionais.",
    )
    .nullish(),
}) as unknown as ToZod<StudentGradeDetailViewModel>;
